import { jwtDecode } from "jwt-decode";
import { UserRoles, UserStatus } from "../types/user.types";

export interface TokenPayload {
  userId: number;
  roleId: UserRoles;
  userStatus: UserStatus;
  teamId?: number | null;
  expiresIn: string;
}

export const decodeToken = (token: string): TokenPayload | null => {
  try {
    return jwtDecode<TokenPayload>(token);
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};
